<template>
  <div class="card-title">
    <img
      class="card-title__bg"
      v-if="!noBg"
      src="@/assets/image/homeIndex/card_title_bg.png"
      alt=""
    />
    <div class="card-title__content">
      <span class="card-title__text">{{ title }}</span>
      <span v-if="subtitle" class="card-title__subtitle">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CardTitle',
  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    noBg: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card-title {
  position: relative;
  width: 100%;
  height: 38px;
  display: flex;
  padding-left: 16px;
  box-sizing: border-box;
  padding-top: 4px;

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    pointer-events: none;
  }

  &__content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: baseline;
    padding-left: 16px;
    gap: 12px;
  }

  &__text {
    font-size: 24px;
    color: #fff;
    font-family: 'PangMenZhengDao';
    letter-spacing: 2px;
    text-shadow: 0px 0px 10px rgba(0, 144, 255, 0.6);
  }

  &__subtitle {
    font-size: 8px;
    color: #33cdff;
    letter-spacing: 1px;
  }
}
</style>
